import m from './module';
import Page from '../model/Page';
import Form from '../model/Form';
import {
  getProvisionalIdentifierForType,
  sortItems,
  resetItemsDisplayOrder,
} from '../util';

const multiLanguageFields = ['name'];

class PageService {
  constructor(
    $q,
    $log,
    FieldInstanceService,
    FormService,
    LanguageService,
    LogService
  ) {
    "ngInject";
    this.$q = $q;
    this.$log = $log;
    this.FieldInstanceService = FieldInstanceService;
    this.FormService = FormService;
    this.LanguageService = LanguageService;
    this.LogService = LogService;
  }

  _splitItems(items) {
    let fieldInstances = [];
    let forms = [];
    for (let item of items) {
      if (item instanceof Form) {
        forms.push(item);
      } else {
        fieldInstances.push(item);
      }
    }
    return [fieldInstances, forms];
  }

  create(data) {
    data = data || {};
    data.id = data.id || getProvisionalIdentifierForType('page');

    // Populate multi-language fields
    data = this.LanguageService.populateMultiLanguageFields(data, multiLanguageFields);

    let pageId = data.id || null;
    let recapDefinitionId = data.recapDefinitionId || data.events_recaps_id || null;

    const items = data.items || [];
    const itemsPromise = this.$q
      .all(items.map(item => {
        if (item['items']) {
          return this.$q.when(
            this.FormService.create({
              ...item,
              recapDefinitionId,
            })
          )
            .catch(err => {
              this.LogService.warn(`PageService.create() swallowing error creating Form ${item.id} for page ${data.id}:`, err);
              return null;
            })
        }
        return this.$q.when(
          this.FieldInstanceService.create({
            ...item,
            recapDefinitionId,
          })
            .catch(err => {
              this.LogService.warn(`PageService.create() swallowing error creating FieldInstance ${item.id} for page ${data.id}:`, err);
              return null;
            })
        )
      }))
      // Filter out nulls
      .then(allItems => allItems.filter(item => !!item))
      .then(allItems => data.items = allItems);

    return this.$q.all([itemsPromise])
      .then(() => new Page(data))
      .catch(err => {
        this.$log.error(`Error creating page ${pageId} on recap definition ${recapDefinitionId}:`, err);
        return this.$q.reject(err);
      });
  }

  serialize(page) {
    resetItemsDisplayOrder(page.items);
    const fieldInstancesAndForms = this._splitItems(page.items);
    const fieldInstances = fieldInstancesAndForms[0].map(field => this.FieldInstanceService.serialize(field));
    const forms = fieldInstancesAndForms[1].map(form => this.FormService.serialize(form));
    const serializedItems = sortItems([...fieldInstances, ...forms]);
    let data = {
      id: page.id,
      name: page.name,
      name_l10n: page.name_l10n,
      items: serializedItems,
      display_order: page.display_order
    };
    data = this.LanguageService.populateMultiLanguageFields(data, multiLanguageFields);
    return data;
  }
}

export default PageService;

m.service('PageService', PageService);
